/*================================================================
‘Copyright © 2020, Cheers Interactive Pvt Ltd.  All rights reserved.
      File Description : Company basic tab action buttons
 --------------------------------------------------------------------------------- 
    Creation Details 
    Date Created				: 25/Jun/2020 
    Author						: Anand Kumar
================================================================ 
*/

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { actionSuccess, actionError } from "../../../../../middleware/actions/utilityAction";
import { setClickSaveSubmitState, setOverviewUpdateStatus } from "../../../../../middleware/actions/companyAction";
import { useDispatch, useSelector } from "react-redux";
import { accessRightActionCheck, getLoggedInUser } from "../../../../../utilities";
import { showAlertBox } from "../../../../../middleware/actions/alertBoxAction";
import { processingSubmit, processingFinalSubmit } from "../../../../../middleware/services/cmsApi";
import CompanyDataPublicUI from "../../../dataPublishing/company/actionButton";
import "../../../../components/popup/index.scss";
import { COMMON_ACCESS_ACTION } from "../../../../../constants";
import PropTypes from "prop-types";
import { fetchOverview } from "middleware/services/companyApi";

const ActionButtons = (props) => {
  const { accessRights: aR } = props;
  const dispatch = useDispatch();
  const companyId = props.companyId;
  const loggedInUser = getLoggedInUser();
  const updateStatus = useSelector((state) => state.companyState.updateStatus);
  const clickStatus = useSelector((state) => state.companyState.clickStatus);
  const [interfaceActionAccess, setInterfaceActionAccess] = useState([]);

  /* Interface action access from common access */
  useEffect(() => {
    let interfaceName = Object.values(props?.hashArr)[props.selectedIndex];
    let actionAccess = accessRightActionCheck(aR.moduleName, interfaceName);
    setInterfaceActionAccess(actionAccess);
  }, [props.selectedIndex]);

  /* Common access */
  const accessActionSubmit = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.SUBMIT);
  const accessActionFinalSubmit = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.FINAL_SUBMIT);
  const accessActionPublish = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.PUBLISH);

  useEffect(() => {
    if (updateStatus && props.selectedIndex === 0) {
      dispatch(
        showAlertBox({
          okCallback: async () => {
            processingSubmit(companyId, "basic", { userId: loggedInUser._id })
              .then((response) => {
                dispatch(actionSuccess(`Company successfully Saved & Submitted`));
              })
              .catch((err) => {
                console.log(err?.data?.message);
                dispatch(actionError(err?.data?.message || "Something went wrong"));
              });
            dispatch(setClickSaveSubmitState());
            dispatch(setOverviewUpdateStatus(false));
          },
          cancelCallback: () => {
            dispatch(setClickSaveSubmitState());
            dispatch(setOverviewUpdateStatus(false));
          },
          okText: "Submit",
          cancelText: "Cancel",
          content: "Are you sure you want to submit ? ",
          title: "dialogAlertCss",
        })
      );
    }
  }, [updateStatus]);
  return (
    <>
      <div>
        {props.selectedIndex > -1 ? (
          <button
            type="button"
            className="cy-test-btn btn btn-outline-dark cy-btn"
            onClick={() => {
              props.selectedIndex < 4 && props.setCurrentTab(props.selectedIndex + 1);
            }}
          >
            Next
          </button>
        ) : null}
      </div>
      <div style={{ display: "flex", gap: "1rem" }}>
        <Link to="/company-old">
          <button type="button" className="cy-test-btn btn btn-outline-dark cy-btn">
            Cancel
          </button>
        </Link>
        {accessActionSubmit ? (
          <button
            type="button"
            className="btn btn-primary cy-btn"
            onClick={() => {
              if (clickStatus)
                // dispatch(setClickSaveSubmitState());
                dispatch(setOverviewUpdateStatus(true));
              dispatch(setClickSaveSubmitState(true));
            }}
          >
            Submit
          </button>
        ) : null}
        {accessActionFinalSubmit ? (
          <button
            type="button"
            className="btn btn-primary cy-btn"
            onClick={() => {
              dispatch(
                showAlertBox({
                  okCallback: async () => {
                    fetchOverview(companyId).then((res) => {
                      if (res?.data?.data?.companyTaxonomyGeography?.length > 0) {
                        processingFinalSubmit(companyId, {
                          userId: loggedInUser._id,
                        })
                          .then((response) => {
                            dispatch(actionSuccess("Company successfully Final Submitted."));
                          })
                          .catch((err) => {
                            console.log(err.data.message);
                            dispatch(actionError(err.data.message || "Something went wrong"));
                          });
                      } else {
                        dispatch(actionError("Please select geography tag(s)"));
                      }
                    });
                  },
                  okText: "Submit",
                  cancelText: "Cancel",
                  content: "Are you sure you want to submit ? ",
                  title: "dialogAlertCss",
                })
              );
            }}
          >
            Final Submit
          </button>
        ) : null}
        {accessActionPublish ? <CompanyDataPublicUI companyId={companyId} /> : null}
      </div>
    </>
  );
};
ActionButtons.propTypes = {
  accessRights: PropTypes.arrayOf(PropTypes.string),
  hashArr: PropTypes.array,
  companyId: PropTypes.string,
  selectedIndex: PropTypes.number,
  setCurrentTab: PropTypes.func,
};

export default ActionButtons;
